module.exports = __webpack_public_path__ + "img/38501-038.e264da44.jpg";